export const findMatches = (data: any) => {
  return Object.entries(data).reduce((result: any, [key, value]) => {
    if (typeof value !== "object") {
      result[key] = value;
    }
    return result;
  }, {});
};
